import { TimezoneIcon } from '@calendly/ui/components/icons'
import { getTimezoneName } from '@calendly/timezone-tools'
import { DetailsItem as Item } from '@calendly/booking-kit'

export default ({ value, bookingAppRedesign = false }) => (
  <Item>
    <TimezoneIcon size={bookingAppRedesign ? 'standard' : 'large'} spacingRight={8} data-id="details-item-icon" />
    {getTimezoneName(value)}
  </Item>
)
